/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  FormLabel,
  Grid,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
} from '@mui/material';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { ReactComponent as Clock } from 'assets/icons/clock.svg';
import CountdownTimer from 'component/CountDownTimer/CountdownTimer';
import { pick_date } from 'component/PropertyCreation/PropertyCreation.style';
import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fontsize16, poppins400, poppins500 } from 'theme/common.style';
// import { checkbox_style, pick_date, select_dropdown_retrex, typography_textfield } from "./PropertyCreation.style";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { PauseIcon } from 'component/PropertyTime/PropertyTimer';
import { Ended, Stage1, Stage2, Stage2Final } from 'component/Common/StageTags';
import dayjs, { utc } from 'dayjs';

import styled from '@emotion/styled';
import {
  Moxoseparationinlisting,
  postApiCall,
  stageTwoSwitching,
} from 'api/apiService';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import {
  AGENT_MOVE_TO_Archived,
  BUYER_AUTO_OFFER,
  UPDATE_START_TIME,
} from 'constant/app.config';
import moment from 'moment-timezone';
import { toast } from 'react-toastify';
import { counterCont, counterSub } from './CounterTimer.style';
// import { Button, Grid } from "antd";
import { useTheme } from '@emotion/react';
import EnhancedTable from 'component/BuyerRegistration/Table';
import Swal from 'sweetalert2';
import Timerstatus from './Timerstatus';
import CommenceStageTwo from 'component/VendorStatusContainer/CommenceStageTwo';
import Stage2Commence from 'component/BuyerOfferCard/Stage2Commence';
import { Pendingwarning } from 'component/BuyersMarketplace/Marketplaceicons';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import timezone from 'dayjs/plugin/timezone';
import Loading from 'assets/images/loading.png';

const StageIcon = () => {
  return (
    <svg
      width="70"
      height="21"
      viewBox="0 0 70 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.390625" width="70" height="20" rx="2" fill="#10D35E" />
      <path
        d="M15.9036 14.4746C15.3196 14.4746 14.7916 14.3746 14.3196 14.1746C13.8556 13.9746 13.4876 13.6866 13.2156 13.3106C12.9436 12.9346 12.8036 12.4906 12.7956 11.9786H14.5956C14.6196 12.3226 14.7396 12.5946 14.9556 12.7946C15.1796 12.9946 15.4836 13.0946 15.8676 13.0946C16.2596 13.0946 16.5676 13.0026 16.7916 12.8186C17.0156 12.6266 17.1276 12.3786 17.1276 12.0746C17.1276 11.8266 17.0516 11.6226 16.8996 11.4626C16.7476 11.3026 16.5556 11.1786 16.3236 11.0906C16.0996 10.9946 15.7876 10.8906 15.3876 10.7786C14.8436 10.6186 14.3996 10.4626 14.0556 10.3106C13.7196 10.1506 13.4276 9.91462 13.1796 9.60262C12.9396 9.28262 12.8196 8.85862 12.8196 8.33063C12.8196 7.83462 12.9436 7.40262 13.1916 7.03462C13.4396 6.66662 13.7876 6.38662 14.2356 6.19462C14.6836 5.99462 15.1956 5.89462 15.7716 5.89462C16.6356 5.89462 17.3356 6.10662 17.8716 6.53062C18.4156 6.94662 18.7156 7.53062 18.7716 8.28262H16.9236C16.9076 7.99462 16.7836 7.75862 16.5516 7.57462C16.3276 7.38262 16.0276 7.28662 15.6516 7.28662C15.3236 7.28662 15.0596 7.37062 14.8596 7.53862C14.6676 7.70662 14.5716 7.95062 14.5716 8.27062C14.5716 8.49462 14.6436 8.68262 14.7876 8.83462C14.9396 8.97862 15.1236 9.09862 15.3396 9.19462C15.5636 9.28262 15.8756 9.38662 16.2756 9.50662C16.8196 9.66662 17.2636 9.82662 17.6076 9.98662C17.9516 10.1466 18.2476 10.3866 18.4956 10.7066C18.7436 11.0266 18.8676 11.4466 18.8676 11.9666C18.8676 12.4146 18.7516 12.8306 18.5196 13.2146C18.2876 13.5986 17.9476 13.9066 17.4996 14.1386C17.0516 14.3626 16.5196 14.4746 15.9036 14.4746ZM26.0241 6.01462V7.37062H23.7921V14.3906H22.1121V7.37062H19.8801V6.01462H26.0241ZM32.3859 12.7946H29.0499L28.4979 14.3906H26.7339L29.7459 6.00262H31.7019L34.7139 14.3906H32.9379L32.3859 12.7946ZM31.9299 11.4506L30.7179 7.94662L29.5059 11.4506H31.9299ZM41.6717 8.53462C41.4797 8.18262 41.2157 7.91462 40.8797 7.73062C40.5437 7.54662 40.1517 7.45462 39.7037 7.45462C39.2077 7.45462 38.7677 7.56662 38.3837 7.79062C37.9997 8.01462 37.6997 8.33462 37.4837 8.75062C37.2677 9.16662 37.1597 9.64662 37.1597 10.1906C37.1597 10.7506 37.2677 11.2386 37.4837 11.6546C37.7077 12.0706 38.0157 12.3906 38.4077 12.6146C38.7997 12.8386 39.2557 12.9506 39.7757 12.9506C40.4157 12.9506 40.9397 12.7826 41.3477 12.4466C41.7557 12.1026 42.0237 11.6266 42.1517 11.0186H39.2717V9.73462H43.8077V11.1986C43.6957 11.7826 43.4557 12.3226 43.0877 12.8186C42.7197 13.3146 42.2437 13.7146 41.6597 14.0186C41.0837 14.3146 40.4357 14.4626 39.7157 14.4626C38.9077 14.4626 38.1757 14.2826 37.5197 13.9226C36.8717 13.5546 36.3597 13.0466 35.9837 12.3986C35.6157 11.7506 35.4317 11.0146 35.4317 10.1906C35.4317 9.36662 35.6157 8.63062 35.9837 7.98262C36.3597 7.32662 36.8717 6.81862 37.5197 6.45862C38.1757 6.09062 38.9037 5.90662 39.7037 5.90662C40.6477 5.90662 41.4677 6.13862 42.1637 6.60262C42.8597 7.05862 43.3397 7.70262 43.6037 8.53462H41.6717ZM46.7307 7.37062V9.47062H49.5507V10.8026H46.7307V13.0226H49.9107V14.3906H45.0507V6.00262H49.9107V7.37062H46.7307ZM53.9008 7.19062V5.64262H56.7928V14.3906H55.0648V7.19062H53.9008Z"
        fill="white"
      />
    </svg>
  );
};

const StageIcon2 = () => {
  return (
    <svg
      width="178"
      height="21"
      viewBox="0 0 178 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.222656"
        width="177"
        height="20"
        rx="2"
        fill="#F93939"
      />
      <path
        d="M16.4649 14.3067C15.8809 14.3067 15.3529 14.2067 14.8809 14.0067C14.4169 13.8067 14.0489 13.5187 13.7769 13.1427C13.5049 12.7667 13.3649 12.3227 13.3569 11.8107H15.1569C15.1809 12.1547 15.3009 12.4267 15.5169 12.6267C15.7409 12.8267 16.0449 12.9267 16.4289 12.9267C16.8209 12.9267 17.1289 12.8347 17.3529 12.6507C17.5769 12.4587 17.6889 12.2107 17.6889 11.9067C17.6889 11.6587 17.6129 11.4547 17.4609 11.2947C17.3089 11.1347 17.1169 11.0107 16.8849 10.9227C16.6609 10.8267 16.3489 10.7227 15.9489 10.6107C15.4049 10.4507 14.9609 10.2947 14.6169 10.1427C14.2809 9.98266 13.9889 9.74666 13.7409 9.43466C13.5009 9.11466 13.3809 8.69066 13.3809 8.16266C13.3809 7.66666 13.5049 7.23466 13.7529 6.86666C14.0009 6.49866 14.3489 6.21866 14.7969 6.02666C15.2449 5.82666 15.7569 5.72666 16.3329 5.72666C17.1969 5.72666 17.8969 5.93866 18.4329 6.36266C18.9769 6.77866 19.2769 7.36266 19.3329 8.11466H17.4849C17.4689 7.82666 17.3449 7.59066 17.1129 7.40666C16.8889 7.21466 16.5889 7.11866 16.2129 7.11866C15.8849 7.11866 15.6209 7.20266 15.4209 7.37066C15.2289 7.53866 15.1329 7.78266 15.1329 8.10266C15.1329 8.32666 15.2049 8.51466 15.3489 8.66666C15.5009 8.81066 15.6849 8.93066 15.9009 9.02666C16.1249 9.11466 16.4369 9.21866 16.8369 9.33866C17.3809 9.49866 17.8249 9.65866 18.1689 9.81866C18.5129 9.97866 18.8089 10.2187 19.0569 10.5387C19.3049 10.8587 19.4289 11.2787 19.4289 11.7987C19.4289 12.2467 19.3129 12.6627 19.0809 13.0467C18.8489 13.4307 18.5089 13.7387 18.0609 13.9707C17.6129 14.1947 17.0809 14.3067 16.4649 14.3067ZM27.1854 5.84666V7.20266H24.9534V14.2227H23.2734V7.20266H21.0414V5.84666H27.1854ZM34.1472 12.6267H30.8112L30.2592 14.2227H28.4952L31.5072 5.83466H33.4632L36.4752 14.2227H34.6992L34.1472 12.6267ZM33.6912 11.2827L32.4792 7.77866L31.2672 11.2827H33.6912ZM44.033 8.36666C43.841 8.01466 43.577 7.74666 43.241 7.56266C42.905 7.37866 42.513 7.28666 42.065 7.28666C41.569 7.28666 41.129 7.39866 40.745 7.62266C40.361 7.84666 40.061 8.16666 39.845 8.58266C39.629 8.99866 39.521 9.47866 39.521 10.0227C39.521 10.5827 39.629 11.0707 39.845 11.4867C40.069 11.9027 40.377 12.2227 40.769 12.4467C41.161 12.6707 41.617 12.7827 42.137 12.7827C42.777 12.7827 43.301 12.6147 43.709 12.2787C44.117 11.9347 44.385 11.4587 44.513 10.8507H41.633V9.56666H46.169V11.0307C46.057 11.6147 45.817 12.1547 45.449 12.6507C45.081 13.1467 44.605 13.5467 44.021 13.8507C43.445 14.1467 42.797 14.2947 42.077 14.2947C41.269 14.2947 40.537 14.1147 39.881 13.7547C39.233 13.3867 38.721 12.8787 38.345 12.2307C37.977 11.5827 37.793 10.8467 37.793 10.0227C37.793 9.19866 37.977 8.46266 38.345 7.81466C38.721 7.15866 39.233 6.65066 39.881 6.29066C40.537 5.92266 41.265 5.73866 42.065 5.73866C43.009 5.73866 43.829 5.97066 44.525 6.43466C45.221 6.89066 45.701 7.53466 45.965 8.36666H44.033ZM49.692 7.20266V9.30266H52.512V10.6347H49.692V12.8547H52.872V14.2227H48.012V5.83466H52.872V7.20266H49.692ZM58.7941 12.3267C59.5621 11.6867 60.1741 11.1547 60.6301 10.7307C61.0861 10.2987 61.4661 9.85066 61.7701 9.38666C62.0741 8.92266 62.2261 8.46666 62.2261 8.01866C62.2261 7.61066 62.1301 7.29066 61.9381 7.05866C61.7461 6.82666 61.4501 6.71066 61.0501 6.71066C60.6501 6.71066 60.3421 6.84666 60.1261 7.11866C59.9101 7.38266 59.7981 7.74666 59.7901 8.21066H58.1581C58.1901 7.25066 58.4741 6.52266 59.0101 6.02666C59.5541 5.53066 60.2421 5.28266 61.0741 5.28266C61.9861 5.28266 62.6861 5.52666 63.1741 6.01466C63.6621 6.49466 63.9061 7.13066 63.9061 7.92266C63.9061 8.54666 63.7381 9.14266 63.4021 9.71066C63.0661 10.2787 62.6821 10.7747 62.2501 11.1987C61.8181 11.6147 61.2541 12.1187 60.5581 12.7107H64.0981V14.1027H58.1701V12.8547L58.7941 12.3267ZM74.5201 9.23066V10.6467H69.4321V9.23066H74.5201ZM85.6355 5.84666V7.20266H82.1435V9.35066H84.8195V10.6827H82.1435V14.2227H80.4635V5.84666H85.6355ZM89.1068 5.84666V14.2227H87.4268V5.84666H89.1068ZM98.5307 14.2227H96.8507L93.0467 8.47466V14.2227H91.3667V5.83466H93.0467L96.8507 11.5947V5.83466H98.5307V14.2227ZM105.927 12.6267H102.591L102.039 14.2227H100.275L103.287 5.83466H105.243L108.255 14.2227H106.479L105.927 12.6267ZM105.471 11.2827L104.259 7.77866L103.047 11.2827H105.471ZM111.661 12.8907H114.421V14.2227H109.981V5.84666H111.661V12.8907ZM123.436 14.3067C122.652 14.3067 121.932 14.1227 121.276 13.7547C120.62 13.3867 120.1 12.8787 119.716 12.2307C119.332 11.5747 119.14 10.8347 119.14 10.0107C119.14 9.19466 119.332 8.46266 119.716 7.81466C120.1 7.15866 120.62 6.64666 121.276 6.27866C121.932 5.91066 122.652 5.72666 123.436 5.72666C124.228 5.72666 124.948 5.91066 125.596 6.27866C126.252 6.64666 126.768 7.15866 127.144 7.81466C127.528 8.46266 127.72 9.19466 127.72 10.0107C127.72 10.8347 127.528 11.5747 127.144 12.2307C126.768 12.8787 126.252 13.3867 125.596 13.7547C124.94 14.1227 124.22 14.3067 123.436 14.3067ZM123.436 12.8067C123.94 12.8067 124.384 12.6947 124.768 12.4707C125.152 12.2387 125.452 11.9107 125.668 11.4867C125.884 11.0627 125.992 10.5707 125.992 10.0107C125.992 9.45066 125.884 8.96266 125.668 8.54666C125.452 8.12266 125.152 7.79866 124.768 7.57466C124.384 7.35066 123.94 7.23866 123.436 7.23866C122.932 7.23866 122.484 7.35066 122.092 7.57466C121.708 7.79866 121.408 8.12266 121.192 8.54666C120.976 8.96266 120.868 9.45066 120.868 10.0107C120.868 10.5707 120.976 11.0627 121.192 11.4867C121.408 11.9107 121.708 12.2387 122.092 12.4707C122.484 12.6947 122.932 12.8067 123.436 12.8067ZM134.742 5.84666V7.20266H131.25V9.35066H133.926V10.6827H131.25V14.2227H129.57V5.84666H134.742ZM141.705 5.84666V7.20266H138.213V9.35066H140.889V10.6827H138.213V14.2227H136.533V5.84666H141.705ZM145.176 7.20266V9.30266H147.996V10.6347H145.176V12.8547H148.356V14.2227H143.496V5.83466H148.356V7.20266H145.176ZM154.803 14.2227L152.955 10.9587H152.163V14.2227H150.483V5.84666H153.627C154.275 5.84666 154.827 5.96266 155.283 6.19466C155.739 6.41866 156.079 6.72666 156.303 7.11866C156.535 7.50266 156.651 7.93466 156.651 8.41466C156.651 8.96666 156.491 9.46666 156.171 9.91466C155.851 10.3547 155.375 10.6587 154.743 10.8267L156.747 14.2227H154.803ZM152.163 9.69866H153.567C154.023 9.69866 154.363 9.59066 154.587 9.37466C154.811 9.15066 154.923 8.84266 154.923 8.45066C154.923 8.06666 154.811 7.77066 154.587 7.56266C154.363 7.34666 154.023 7.23866 153.567 7.23866H152.163V9.69866ZM161.663 14.3067C161.079 14.3067 160.551 14.2067 160.079 14.0067C159.615 13.8067 159.247 13.5187 158.975 13.1427C158.703 12.7667 158.563 12.3227 158.555 11.8107H160.355C160.379 12.1547 160.499 12.4267 160.715 12.6267C160.939 12.8267 161.243 12.9267 161.627 12.9267C162.019 12.9267 162.327 12.8347 162.551 12.6507C162.775 12.4587 162.887 12.2107 162.887 11.9067C162.887 11.6587 162.811 11.4547 162.659 11.2947C162.507 11.1347 162.315 11.0107 162.083 10.9227C161.859 10.8267 161.547 10.7227 161.147 10.6107C160.603 10.4507 160.159 10.2947 159.815 10.1427C159.479 9.98266 159.187 9.74666 158.939 9.43466C158.699 9.11466 158.579 8.69066 158.579 8.16266C158.579 7.66666 158.703 7.23466 158.951 6.86666C159.199 6.49866 159.547 6.21866 159.995 6.02666C160.443 5.82666 160.955 5.72666 161.531 5.72666C162.395 5.72666 163.095 5.93866 163.631 6.36266C164.175 6.77866 164.475 7.36266 164.531 8.11466H162.683C162.667 7.82666 162.543 7.59066 162.311 7.40666C162.087 7.21466 161.787 7.11866 161.411 7.11866C161.083 7.11866 160.819 7.20266 160.619 7.37066C160.427 7.53866 160.331 7.78266 160.331 8.10266C160.331 8.32666 160.403 8.51466 160.547 8.66666C160.699 8.81066 160.883 8.93066 161.099 9.02666C161.323 9.11466 161.635 9.21866 162.035 9.33866C162.579 9.49866 163.023 9.65866 163.367 9.81866C163.711 9.97866 164.007 10.2187 164.255 10.5387C164.503 10.8587 164.627 11.2787 164.627 11.7987C164.627 12.2467 164.511 12.6627 164.279 13.0467C164.047 13.4307 163.707 13.7387 163.259 13.9707C162.811 14.1947 162.279 14.3067 161.663 14.3067Z"
        fill="white"
      />
    </svg>
  );
};
const Stage2SVG = () => {
  return (
    <svg
      width="79"
      height="28"
      viewBox="0 0 79 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.486328" width="77.6119" height="28" fill="#F93939" />
      <path
        d="M15.2195 20.098C14.5755 20.098 13.9968 19.986 13.4835 19.762C12.9795 19.5287 12.5828 19.2113 12.2935 18.81C12.0041 18.3993 11.8548 17.928 11.8455 17.396H13.2035C13.2501 17.8533 13.4368 18.2407 13.7635 18.558C14.0995 18.866 14.5848 19.02 15.2195 19.02C15.8261 19.02 16.3021 18.8707 16.6475 18.572C17.0021 18.264 17.1795 17.872 17.1795 17.396C17.1795 17.0227 17.0768 16.7193 16.8715 16.486C16.6661 16.2527 16.4095 16.0753 16.1015 15.954C15.7935 15.8327 15.3781 15.702 14.8555 15.562C14.2115 15.394 13.6935 15.226 13.3015 15.058C12.9188 14.89 12.5875 14.6287 12.3075 14.274C12.0368 13.91 11.9015 13.4247 11.9015 12.818C11.9015 12.286 12.0368 11.8147 12.3075 11.404C12.5781 10.9933 12.9561 10.676 13.4415 10.452C13.9361 10.228 14.5008 10.116 15.1355 10.116C16.0501 10.116 16.7968 10.3447 17.3755 10.802C17.9635 11.2593 18.2948 11.866 18.3695 12.622H16.9695C16.9228 12.2487 16.7268 11.922 16.3815 11.642C16.0361 11.3527 15.5788 11.208 15.0095 11.208C14.4775 11.208 14.0435 11.348 13.7075 11.628C13.3715 11.8987 13.2035 12.2813 13.2035 12.776C13.2035 13.1307 13.3015 13.42 13.4975 13.644C13.7028 13.868 13.9501 14.0407 14.2395 14.162C14.5381 14.274 14.9535 14.4047 15.4855 14.554C16.1295 14.7313 16.6475 14.9087 17.0395 15.086C17.4315 15.254 17.7675 15.52 18.0475 15.884C18.3275 16.2387 18.4675 16.724 18.4675 17.34C18.4675 17.816 18.3415 18.264 18.0895 18.684C17.8375 19.104 17.4641 19.4447 16.9695 19.706C16.4748 19.9673 15.8915 20.098 15.2195 20.098ZM22.5963 13.378V17.9C22.5963 18.2733 22.6756 18.5393 22.8343 18.698C22.9929 18.8473 23.2683 18.922 23.6603 18.922H24.5983V20H23.4503C22.7409 20 22.2089 19.8367 21.8543 19.51C21.4996 19.1833 21.3223 18.6467 21.3223 17.9V13.378H20.3283V12.328H21.3223V10.396H22.5963V12.328H24.5983V13.378H22.5963ZM26.3659 16.136C26.3659 15.352 26.5245 14.666 26.8419 14.078C27.1592 13.4807 27.5932 13.0187 28.1439 12.692C28.7039 12.3653 29.3245 12.202 30.0059 12.202C30.6779 12.202 31.2612 12.3467 31.7559 12.636C32.2505 12.9253 32.6192 13.2893 32.8619 13.728V12.328H34.1499V20H32.8619V18.572C32.6099 19.02 32.2319 19.3933 31.7279 19.692C31.2332 19.9813 30.6545 20.126 29.9919 20.126C29.3105 20.126 28.6945 19.958 28.1439 19.622C27.5932 19.286 27.1592 18.8147 26.8419 18.208C26.5245 17.6013 26.3659 16.9107 26.3659 16.136ZM32.8619 16.15C32.8619 15.5713 32.7452 15.0673 32.5119 14.638C32.2785 14.2087 31.9612 13.882 31.5599 13.658C31.1679 13.4247 30.7339 13.308 30.2579 13.308C29.7819 13.308 29.3479 13.42 28.9559 13.644C28.5639 13.868 28.2512 14.1947 28.0179 14.624C27.7845 15.0533 27.6679 15.5573 27.6679 16.136C27.6679 16.724 27.7845 17.2373 28.0179 17.676C28.2512 18.1053 28.5639 18.4367 28.9559 18.67C29.3479 18.894 29.7819 19.006 30.2579 19.006C30.7339 19.006 31.1679 18.894 31.5599 18.67C31.9612 18.4367 32.2785 18.1053 32.5119 17.676C32.7452 17.2373 32.8619 16.7287 32.8619 16.15ZM40.1668 12.202C40.8295 12.202 41.4081 12.3467 41.9028 12.636C42.4068 12.9253 42.7801 13.2893 43.0228 13.728V12.328H44.3108V20.168C44.3108 20.868 44.1615 21.4887 43.8628 22.03C43.5641 22.5807 43.1348 23.01 42.5748 23.318C42.0241 23.626 41.3801 23.78 40.6428 23.78C39.6348 23.78 38.7948 23.542 38.1228 23.066C37.4508 22.59 37.0541 21.9413 36.9328 21.12H38.1928C38.3328 21.5867 38.6221 21.96 39.0608 22.24C39.4995 22.5293 40.0268 22.674 40.6428 22.674C41.3428 22.674 41.9121 22.4547 42.3508 22.016C42.7988 21.5773 43.0228 20.9613 43.0228 20.168V18.558C42.7708 19.006 42.3975 19.3793 41.9028 19.678C41.4081 19.9767 40.8295 20.126 40.1668 20.126C39.4855 20.126 38.8648 19.958 38.3048 19.622C37.7541 19.286 37.3201 18.8147 37.0028 18.208C36.6855 17.6013 36.5268 16.9107 36.5268 16.136C36.5268 15.352 36.6855 14.666 37.0028 14.078C37.3201 13.4807 37.7541 13.0187 38.3048 12.692C38.8648 12.3653 39.4855 12.202 40.1668 12.202ZM43.0228 16.15C43.0228 15.5713 42.9061 15.0673 42.6728 14.638C42.4395 14.2087 42.1221 13.882 41.7208 13.658C41.3288 13.4247 40.8948 13.308 40.4188 13.308C39.9428 13.308 39.5088 13.42 39.1168 13.644C38.7248 13.868 38.4121 14.1947 38.1788 14.624C37.9455 15.0533 37.8288 15.5573 37.8288 16.136C37.8288 16.724 37.9455 17.2373 38.1788 17.676C38.4121 18.1053 38.7248 18.4367 39.1168 18.67C39.5088 18.894 39.9428 19.006 40.4188 19.006C40.8948 19.006 41.3288 18.894 41.7208 18.67C42.1221 18.4367 42.4395 18.1053 42.6728 17.676C42.9061 17.2373 43.0228 16.7287 43.0228 16.15ZM54.1637 15.87C54.1637 16.1127 54.1497 16.3693 54.1217 16.64H47.9897C48.0364 17.396 48.2931 17.9887 48.7597 18.418C49.2357 18.838 49.8097 19.048 50.4817 19.048C51.0324 19.048 51.4897 18.922 51.8537 18.67C52.2271 18.4087 52.4884 18.0633 52.6377 17.634H54.0097C53.8044 18.3713 53.3937 18.9733 52.7777 19.44C52.1617 19.8973 51.3964 20.126 50.4817 20.126C49.7537 20.126 49.1004 19.9627 48.5217 19.636C47.9524 19.3093 47.5044 18.8473 47.1777 18.25C46.8511 17.6433 46.6877 16.9433 46.6877 16.15C46.6877 15.3567 46.8464 14.6613 47.1637 14.064C47.4811 13.4667 47.9244 13.0093 48.4937 12.692C49.0724 12.3653 49.7351 12.202 50.4817 12.202C51.2097 12.202 51.8537 12.3607 52.4137 12.678C52.9737 12.9953 53.4031 13.434 53.7017 13.994C54.0097 14.5447 54.1637 15.17 54.1637 15.87ZM52.8477 15.604C52.8477 15.1187 52.7404 14.7033 52.5257 14.358C52.3111 14.0033 52.0171 13.7373 51.6437 13.56C51.2797 13.3733 50.8737 13.28 50.4257 13.28C49.7817 13.28 49.2311 13.4853 48.7737 13.896C48.3257 14.3067 48.0691 14.876 48.0037 15.604H52.8477ZM60.6138 18.978C61.7991 18.026 62.7278 17.2467 63.3998 16.64C64.0718 16.024 64.6365 15.3847 65.0938 14.722C65.5605 14.05 65.7938 13.392 65.7938 12.748C65.7938 12.1413 65.6445 11.6653 65.3458 11.32C65.0565 10.9653 64.5851 10.788 63.9318 10.788C63.2971 10.788 62.8025 10.9887 62.4478 11.39C62.1025 11.782 61.9158 12.3093 61.8878 12.972H60.6558C60.6931 11.9267 61.0105 11.1193 61.6078 10.55C62.2051 9.98067 62.9751 9.696 63.9178 9.696C64.8791 9.696 65.6398 9.962 66.1998 10.494C66.7691 11.026 67.0538 11.7587 67.0538 12.692C67.0538 13.4667 66.8205 14.2227 66.3538 14.96C65.8965 15.688 65.3738 16.332 64.7858 16.892C64.1978 17.4427 63.4465 18.0867 62.5318 18.824H67.3478V19.888H60.6138V18.978Z"
        fill="white"
      />
    </svg>
  );
};
const Unpublished = () => {
  return (
    <svg
      width="97"
      height="26"
      viewBox="0 0 97 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.509766"
        y="0.605469"
        width="96"
        height="25"
        rx="5"
        fill="#529AEE"
      />
      <path
        d="M12.9666 8.74147V14.0335C12.9666 14.7775 13.1466 15.3295 13.5066 15.6895C13.8746 16.0495 14.3826 16.2295 15.0306 16.2295C15.6706 16.2295 16.1706 16.0495 16.5306 15.6895C16.8986 15.3295 17.0826 14.7775 17.0826 14.0335V8.74147H18.1746V14.0215C18.1746 14.7175 18.0346 15.3055 17.7546 15.7855C17.4746 16.2575 17.0946 16.6095 16.6146 16.8415C16.1426 17.0735 15.6106 17.1895 15.0186 17.1895C14.4266 17.1895 13.8906 17.0735 13.4106 16.8415C12.9386 16.6095 12.5626 16.2575 12.2826 15.7855C12.0106 15.3055 11.8746 14.7175 11.8746 14.0215V8.74147H12.9666ZM23.2003 10.4095C24.0003 10.4095 24.6483 10.6535 25.1443 11.1415C25.6403 11.6215 25.8883 12.3175 25.8883 13.2295V17.1055H24.8083V13.3855C24.8083 12.7295 24.6443 12.2295 24.3163 11.8855C23.9883 11.5335 23.5403 11.3575 22.9723 11.3575C22.3963 11.3575 21.9363 11.5375 21.5923 11.8975C21.2563 12.2575 21.0883 12.7815 21.0883 13.4695V17.1055H19.9963V10.5295H21.0883V11.4655C21.3043 11.1295 21.5963 10.8695 21.9643 10.6855C22.3403 10.5015 22.7523 10.4095 23.2003 10.4095ZM28.764 11.7415C28.98 11.3655 29.3 11.0535 29.724 10.8055C30.156 10.5495 30.656 10.4215 31.224 10.4215C31.808 10.4215 32.336 10.5615 32.808 10.8415C33.288 11.1215 33.664 11.5175 33.936 12.0295C34.208 12.5335 34.344 13.1215 34.344 13.7935C34.344 14.4575 34.208 15.0495 33.936 15.5695C33.664 16.0895 33.288 16.4935 32.808 16.7815C32.336 17.0695 31.808 17.2135 31.224 17.2135C30.664 17.2135 30.168 17.0895 29.736 16.8415C29.312 16.5855 28.988 16.2695 28.764 15.8935V20.2255H27.672V10.5295H28.764V11.7415ZM33.228 13.7935C33.228 13.2975 33.128 12.8655 32.928 12.4975C32.728 12.1295 32.456 11.8495 32.112 11.6575C31.776 11.4655 31.404 11.3695 30.996 11.3695C30.596 11.3695 30.224 11.4695 29.88 11.6695C29.544 11.8615 29.272 12.1455 29.064 12.5215C28.864 12.8895 28.764 13.3175 28.764 13.8055C28.764 14.3015 28.864 14.7375 29.064 15.1135C29.272 15.4815 29.544 15.7655 29.88 15.9655C30.224 16.1575 30.596 16.2535 30.996 16.2535C31.404 16.2535 31.776 16.1575 32.112 15.9655C32.456 15.7655 32.728 15.4815 32.928 15.1135C33.128 14.7375 33.228 14.2975 33.228 13.7935ZM41.6134 10.5295V17.1055H40.5214V16.1335C40.3134 16.4695 40.0214 16.7335 39.6454 16.9255C39.2774 17.1095 38.8694 17.2015 38.4214 17.2015C37.9094 17.2015 37.4494 17.0975 37.0414 16.8895C36.6334 16.6735 36.3094 16.3535 36.0694 15.9295C35.8374 15.5055 35.7214 14.9895 35.7214 14.3815V10.5295H36.8014V14.2375C36.8014 14.8855 36.9654 15.3855 37.2934 15.7375C37.6214 16.0815 38.0694 16.2535 38.6374 16.2535C39.2214 16.2535 39.6814 16.0735 40.0174 15.7135C40.3534 15.3535 40.5214 14.8295 40.5214 14.1415V10.5295H41.6134ZM44.5492 11.7535C44.7732 11.3615 45.1012 11.0415 45.5332 10.7935C45.9652 10.5455 46.4572 10.4215 47.0092 10.4215C47.6012 10.4215 48.1332 10.5615 48.6052 10.8415C49.0772 11.1215 49.4492 11.5175 49.7212 12.0295C49.9932 12.5335 50.1292 13.1215 50.1292 13.7935C50.1292 14.4575 49.9932 15.0495 49.7212 15.5695C49.4492 16.0895 49.0732 16.4935 48.5932 16.7815C48.1212 17.0695 47.5932 17.2135 47.0092 17.2135C46.4412 17.2135 45.9412 17.0895 45.5092 16.8415C45.0852 16.5935 44.7652 16.2775 44.5492 15.8935V17.1055H43.4572V8.22547H44.5492V11.7535ZM49.0132 13.7935C49.0132 13.2975 48.9132 12.8655 48.7132 12.4975C48.5132 12.1295 48.2412 11.8495 47.8972 11.6575C47.5612 11.4655 47.1892 11.3695 46.7812 11.3695C46.3812 11.3695 46.0092 11.4695 45.6652 11.6695C45.3292 11.8615 45.0572 12.1455 44.8492 12.5215C44.6492 12.8895 44.5492 13.3175 44.5492 13.8055C44.5492 14.3015 44.6492 14.7375 44.8492 15.1135C44.8572 15.4815 45.1292 15.7655 45.4652 15.9655C45.8092 16.1575 46.1812 16.2535 46.5812 16.2535C46.9892 16.2535 47.3612 16.1575 47.6972 15.9655C48.0412 15.7655 48.3132 15.4815 48.5132 15.1135C48.7132 14.7375 48.8132 14.2975 48.8132 13.7935H49.0132ZM52.6586 8.22547V17.1055H51.5666V8.22547H52.6586ZM55.0837 9.46147C54.8757 9.46147 54.6997 9.38947 54.5557 9.24547C54.4117 9.10147 54.3397 8.92547 54.3397 8.71747C54.3397 8.50947 54.4117 8.33347 54.5557 8.18947C54.6997 8.04547 54.8757 7.97347 55.0837 7.97347C55.2837 7.97347 55.4517 8.04547 55.5877 8.18947C55.7317 8.33347 55.8037 8.50947 55.8037 8.71747C55.8037 8.92547 55.7317 9.10147 55.5877 9.24547C55.4517 9.38947 55.2837 9.46147 55.0837 9.46147ZM55.6117 10.5295V17.1055H54.5197V10.5295H55.6117ZM59.8008 17.2135C59.2968 17.2135 58.8448 17.1295 58.4448 16.9615C58.0448 16.7855 57.7288 16.5455 57.4968 16.2415C57.2648 15.9295 57.1368 15.5735 57.1128 15.1735H58.2408C58.2728 15.5015 58.4248 15.7695 58.6968 15.9775C58.9768 16.1855 59.3408 16.2895 59.7888 16.2895C60.2048 16.2895 60.5328 16.1975 60.7728 16.0135C61.0128 15.8295 61.1328 15.5975 61.1328 15.3175C61.1328 15.0295 61.0048 14.8175 60.7488 14.6815C60.4928 14.5375 60.0968 14.3975 59.5608 14.2615C59.0728 14.1335 58.6728 14.0055 58.3608 13.8775C58.0568 13.7415 57.7928 13.5455 57.5688 13.2895C57.3528 13.0255 57.2448 12.6815 57.2448 12.2575C57.2448 11.9215 57.3448 11.6135 57.5448 11.3335C57.7448 11.0535 58.0288 10.8335 58.3968 10.6735C58.7648 10.5055 59.1848 10.4215 59.6568 10.4215C60.3848 10.4215 60.9728 10.6055 61.4208 10.9735C61.8688 11.3415 62.1088 11.8455 62.1408 12.4855H61.0488C61.0248 12.1415 60.8848 11.8655 60.6288 11.6575C60.3808 11.4495 60.0448 11.3455 59.6208 11.3455C59.2288 11.3455 58.9168 11.4295 58.6848 11.5975C58.4528 11.7655 58.3368 11.9855 58.3368 12.2575C58.3368 12.4735 58.4048 12.6535 58.5408 12.7975C58.6848 12.9335 58.8608 13.0455 59.0688 13.1335C59.2848 13.2135 59.5808 13.3055 59.9568 13.4095C60.4288 13.5375 60.8128 13.6655 61.1088 13.7935C61.4048 13.9135 61.6568 14.0975 61.8648 14.3455C62.0808 14.5935 62.1928 14.9175 62.2008 15.3175C62.2008 15.6775 62.1008 16.0015 61.9008 16.2895C61.7008 16.5775 61.4168 16.8055 61.0488 16.9735C60.6888 17.1335 60.2728 17.2135 59.8008 17.2135ZM67.0064 10.4095C67.5024 10.4095 67.9504 10.5175 68.3504 10.7335C68.7504 10.9415 69.0624 11.2575 69.2864 11.6815C69.5184 12.1055 69.6344 12.6215 69.6344 13.2295V17.1055H68.5544V13.3855C68.5544 12.7295 68.3904 12.2295 68.0624 11.8855C67.7344 11.5335 67.2864 11.3575 66.7184 11.3575C66.1424 11.3575 65.6824 11.5375 65.3384 11.8975C65.0024 12.2575 64.8344 12.7815 64.8344 13.4695V17.1055H63.7424V8.22547H64.8344V11.4655C65.0504 11.1295 65.3464 10.8695 65.7224 10.6855C66.1064 10.5015 66.5344 10.4095 67.0064 10.4095ZM77.4181 13.5655C77.4181 13.7735 77.4061 13.9935 77.3821 14.2255H72.1261C72.1661 14.8735 72.3861 15.3815 72.7861 15.7495C73.1941 16.1095 73.6861 16.2895 74.2621 16.2895C74.7341 16.2895 75.1261 16.1815 75.4381 15.9655C75.7581 15.7415 75.9821 15.4455 76.1101 15.0775H77.2861C77.1101 15.7095 76.7581 16.2255 76.2301 16.6255C75.7021 17.0175 75.0461 17.2135 74.2621 17.2135C73.6381 17.2135 73.0781 17.0735 72.5821 16.7935C72.0941 16.5135 71.7101 16.1175 71.4301 15.6055C71.1501 15.0855 71.0101 14.4855 71.0101 13.8055C71.0101 13.1255 71.1461 12.5295 71.4181 12.0175C71.6901 11.5055 72.0701 11.1135 72.5581 10.8415C73.0541 10.5615 73.6221 10.4215 74.2621 10.4215C74.8861 10.4215 75.4381 10.5575 75.9181 10.8295C76.3981 11.1015 76.7661 11.4775 77.0221 11.9575C77.2861 12.4295 77.4181 12.9655 77.4181 13.5655ZM76.2901 13.3375C76.2901 12.9215 76.1981 12.5655 76.0141 12.2695C75.8301 11.9655 75.5781 11.7375 75.2581 11.5855C74.9461 11.4255 74.5981 11.3455 74.2141 11.3455C73.6621 11.3455 73.1901 11.5215 72.7981 11.8735C72.4141 12.2255 72.1941 12.7135 72.1381 13.3375H76.2901ZM78.4515 13.7935C78.4515 13.1215 78.5875 12.5335 78.8595 12.0295C79.1315 11.5175 79.5035 11.1215 79.9755 10.8415C80.4555 10.5615 80.9915 10.4215 81.5835 10.4215C82.0955 10.4215 82.5715 10.5415 83.0115 10.7815C83.4515 11.0135 83.7875 11.3215 84.0195 11.7055V8.22547H85.1235V17.1055H84.0195V15.8695C83.8035 16.2615 83.4835 16.5855 83.0595 16.8415C82.6355 17.0895 82.1395 17.2135 81.5715 17.2135C80.9875 17.2135 80.4555 17.0695 79.9755 16.7815C79.5035 16.4935 79.1315 16.0895 78.8595 15.5695C78.5875 15.0495 78.4515 14.4575 78.4515 13.7935ZM84.0195 13.8055C84.0195 13.3095 83.9195 12.8775 83.7195 12.5095C83.5195 12.1415 83.2475 11.8615 82.9035 11.6695C82.5675 11.4695 82.1955 11.3695 81.7875 11.3695C81.3795 11.3695 81.0075 11.4655 80.6715 11.6575C80.3355 11.8495 80.0675 12.1295 79.8675 12.4975C79.6675 12.8655 79.5675 13.2975 79.5675 13.7935C79.5675 14.2975 79.6675 14.7375 79.8675 15.1135C79.8755 15.4815 80.1475 15.7655 80.4835 15.9655C80.8275 16.1575 81.1995 16.2535 81.5995 16.2535C82.0075 16.2535 82.3795 16.1575 82.7155 15.9655C83.0595 15.7655 83.3315 15.4815 83.5315 15.1135C83.7315 14.7375 83.8315 14.3015 83.8315 13.8055H84.0195Z"
        fill="white"
      />
    </svg>
  );
};
const Dateicon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2V5"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16 2V5"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 9.08984H20.5"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21 8.5V17C21 20 19.5 22 16 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z"
        stroke="#200E32"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6937 13.6992H15.7027"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6937 16.6992H15.7027"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9945 13.6992H12.0035"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9945 16.6992H12.0035"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.29529 13.6992H8.30427"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.29529 16.6992H8.30427"
        stroke="#200E32"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const Timeicon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.51496 1.01896C8.34401 1.00635 8.17225 1 8 1V0C8.19685 0 8.39314 0.00726199 8.58852 0.0216722L8.51496 1.01896ZM10.5193 1.46905C10.1985 1.34533 9.86912 1.2454 9.53371 1.17008L9.75282 0.194382C10.1361 0.280463 10.5126 0.394665 10.8792 0.536055L10.5193 1.46905ZM11.889 2.17971C11.7458 2.08402 11.5994 1.99388 11.4503 1.90939L11.9432 1.0393C12.1136 1.13586 12.2809 1.23888 12.4446 1.34824C12.6082 1.4576 12.7674 1.5727 12.9219 1.69322L12.3066 2.48158C12.1715 2.37612 12.0322 2.27541 11.889 2.17971ZM13.7231 3.96934C13.5252 3.68829 13.3068 3.42218 13.0697 3.17321L13.794 2.48368C14.0649 2.76821 14.3145 3.07233 14.5407 3.39353L13.7231 3.96934ZM14.4672 5.32122C14.4012 5.16208 14.3296 5.00583 14.2526 4.85271L15.1458 4.40311C15.2339 4.5781 15.3157 4.75667 15.391 4.93853C15.4664 5.12039 15.5348 5.30453 15.5962 5.49054L14.6467 5.80423C14.5929 5.64147 14.5331 5.48035 14.4672 5.32122ZM14.9979 7.82822C14.9895 7.48455 14.9557 7.14197 14.8969 6.80326L15.8822 6.63231C15.9494 7.01939 15.988 7.41092 15.9976 7.80367L14.9979 7.82822ZM14.8655 9.36563C14.8991 9.1967 14.9264 9.02699 14.9474 8.85687L15.9398 8.97929C15.9159 9.17372 15.8847 9.36766 15.8463 9.56072C15.8079 9.75378 15.7625 9.94489 15.7102 10.1337L14.7464 9.867C14.7922 9.70179 14.8319 9.53457 14.8655 9.36563ZM13.914 11.745C14.0979 11.4546 14.2602 11.151 14.3995 10.8367L15.3137 11.2419C15.1545 11.6011 14.969 11.9481 14.7588 12.28L13.914 11.745ZM12.9497 12.9497C13.0715 12.828 13.1885 12.702 13.3005 12.5722L14.0577 13.2254C13.9297 13.3737 13.796 13.5177 13.6569 13.6569L12.9497 12.9497Z"
        fill="#212529"
      />
      <path
        d="M8 1C6.84885 1 5.71545 1.2839 4.70022 1.82655C3.68499 2.3692 2.81926 3.15386 2.17971 4.11101C1.54017 5.06816 1.14654 6.16827 1.03371 7.31388C0.920876 8.45949 1.09232 9.61525 1.53285 10.6788C1.97337 11.7423 2.66939 12.6808 3.55925 13.4111C4.44911 14.1414 5.50533 14.6409 6.63437 14.8655C7.76341 15.0901 8.93041 15.0327 10.032 14.6986C11.1336 14.3644 12.1358 13.7637 12.9497 12.9497L13.6569 13.6569C12.7266 14.5871 11.5812 15.2736 10.3223 15.6555C9.06332 16.0374 7.72961 16.1029 6.43928 15.8463C5.14895 15.5896 3.94183 15.0187 2.92486 14.1841C1.90788 13.3495 1.11243 12.2769 0.608966 11.0615C0.105504 9.846 -0.0904279 8.52514 0.0385242 7.21586C0.167476 5.90659 0.617333 4.64933 1.34825 3.55544C2.07916 2.46155 3.06857 1.5648 4.22883 0.94463C5.38909 0.324457 6.68439 0 8 0V1Z"
        fill="#212529"
      />
      <path
        d="M7.5 3C7.77614 3 8 3.22386 8 3.5V8.70984L11.2481 10.5659C11.4878 10.7029 11.5711 11.0083 11.4341 11.2481C11.2971 11.4878 10.9917 11.5711 10.7519 11.4341L7.25193 9.43412C7.09615 9.3451 7 9.17943 7 9V3.5C7 3.22386 7.22386 3 7.5 3Z"
        fill="#212529"
      />
    </svg>
  );
};

function CounterTimer(props) {
  const {
    isUnPublished,
    profileDetails,
    getListInfo,
    Highest,
    dataProfileDetails,
    buyerdata,
    activityfun,
    setPublish,
    buyerregdata,
    offerdata,
    isWinner,
    stage2AcceptanceCertificate,
    setStage2AcceptanceCertificate,
  } = props;
  const [isRunning, setIsRunning] = React.useState(
    profileDetails?.property?.status !== 'Published'
  );
  const stage = profileDetails?.stage;
  const propertystatus = profileDetails?.property?.status;
  const [isStopped, setIsStopped] = React.useState(false);
  const THREE_DAYS_IN_MS = profileDetails?.counter;
  const NOW_IN_MS = new Date().getTime();
  const [dateTimeAfterThreeDays, setdateTimeAfterThreeDays] = useState(0);
  // const [counterTimer, setcounterTimer] = useState(0);

  const params = useParams();
  const data1 = localStorage.getItem('userDetail');

  const userDetail = JSON.parse(data1);
  const [value, setValue] = React.useState('');
  const { setLoaderConfig } = React.useContext(LoaderContext);
  const [action, setAction] = React.useState(profileDetails?.timerStatus || '');
  const [isTimerPaused, setTimerPaused] = useState(false);
  const [timer, setTimer] = useState(0);
  const [pause, SetPause] = useState();
  const [clickpause, SetClickpause] = useState(false);
  const [timerStatus, SetTimerStatus] = useState('');
  const [openCommenceStageTwo, setOpenCommenceStageTwo] = useState(false);
  const onCloseCommenceStageTwo = () => {
    setOpenCommenceStageTwo(false);
  };
  // const [openstagetwoCommence, setstagetwoCommence] = useState(false)

  // useEffect(()=>{
  //   if((dataProfileDetails?.PropertyDetails?.isFirstOfferAccepted == 1) && (profileDetails?.stage == 'ST1') && (dataProfileDetails?.isReminderStage2Log == 1) && (userDetail?.primaryUserType == "Agent") && (dataProfileDetails?.PropertyDetails?.timerStatus == "Start")){
  //     setstagetwoCommence(true)
  //   }
  //   else{
  //     setstagetwoCommence(false)
  //   }
  // },[dataProfileDetails])

  useEffect(() => {
    setAction(profileDetails?.timerStatus || '');

    if (
      profileDetails?.stage !== 0 &&
      profileDetails?.timerStatus === 'Start'
    ) {
      const currentTime = moment().valueOf();
      const dateWithStartAtCal = moment(profileDetails?.startedAt).format();
      const duration = moment.duration(
        profileDetails?.timerDuration,
        'milliseconds'
      );
      const runningDate = moment(dateWithStartAtCal).add(duration).toDate();
      setdateTimeAfterThreeDays(runningDate);
    } else if (
      profileDetails?.stage !== 0 &&
      profileDetails?.timerStatus === 'Pause'
    ) {
      SetPause(profileDetails?.pausedTimerDuration);

      const currentTime = moment().valueOf();
      const dateWithStartAtCal = moment(profileDetails?.startedAt).format();
      const duration = moment.duration(
        profileDetails?.timerDuration,
        'milliseconds'
      );

      const runningDate = moment(dateWithStartAtCal).add(duration).toDate();
      setdateTimeAfterThreeDays(runningDate);
    } else {
      const dateWithStartAtCal = moment(profileDetails?.startedAt).format();
      const runningDate = moment(dateWithStartAtCal).toDate();
      setdateTimeAfterThreeDays(runningDate);
    }
  }, [profileDetails]);

  const {
    winerPublishdMoveToEnded,
    setWinerPublishdMoveToEnded,
    setwinnerPopper,
  } = useContext(PropertyContext);

  const [closeEndedConfirmation, setCloseEndedConfirmation] = useState(false);

  const [isSevenDaysPassed, setIsSevenDaysPassed] = useState(false);
  useEffect(() => {
    const givenDate = new Date(
      dataProfileDetails?.PropertyDetails?.stageUpdatedAt
    );
    const currentDate = new Date(); // Current date
    const timeDifference = currentDate - givenDate; // Time difference in milliseconds
    // Check if 7 days have passed (7 * 24 * 60 * 60 * 1000 milliseconds)
    if (timeDifference >= 7 * 24 * 60 * 60 * 1000) {
      setIsSevenDaysPassed(true);
    }
  }, [dataProfileDetails]);

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  const [startDate, setStartdate] = useState('');
  const [starttime, setStarttime] = useState('');
  const [enddate, setEnddate] = useState('');
  const [endtime, setEndtime] = useState('');

  const [initialValues, setInitialValues] = useState({
    startDate: null,
    starttime: null,
    enddate: null,
    endtime: null,
  });

  const propertyData = props?.dataProfileDetails?.PropertyDetails;

  dayjs.extend(utc);
  dayjs.extend(timezone);
  useEffect(() => {
    if (propertyData?.startedAt && propertyData?.endedAt) {
      const start = dayjs.tz(
        propertyData.startedAt,
        'YYYY-MM-DD HH:mm:ss',
        'Australia/Sydney'
      );
      const end = dayjs.tz(
        propertyData.endedAt,
        'YYYY-MM-DD HH:mm:ss',
        'Australia/Sydney'
      );
      setStartdate(start);
      setStarttime(start);
      setEnddate(end);
      setEndtime(end);

      setInitialValues({
        startDate: start,
        starttime: start,
        enddate: end,
        endtime: end,
      });
    }
  }, [openEditDialog]);

  const normalize = (value) => (value ? dayjs(value) : null);

  const isChanged =
    !normalize(startDate)?.isSame(
      normalize(initialValues.startDate),
      'minute'
    ) ||
    !normalize(starttime)?.isSame(
      normalize(initialValues.starttime),
      'minute'
    ) ||
    !normalize(enddate)?.isSame(normalize(initialValues.enddate), 'minute') ||
    !normalize(endtime)?.isSame(normalize(initialValues.endtime), 'minute');

  const [errorMessageStartDate, setErrorMessageStartDate] = useState(false);
  const [errorMessageEndingDate, setErrorMessageEndingDate] = useState(false);
  const [errorMessageEndTime, setErrorMessageEndTime] = useState(false);
  const [errorMessageStartTime, setErrorMessageStartTime] = useState(false);

  const [unPublishPauseTimer, setUnPublishPauseTimer] = useState(false);

  const handleOpenPause = () => {
    setUnPublishPauseTimer(true);
  };

  // Add Sydney timezone validation logic
  const sydneyNow = dayjs().tz('Australia/Sydney');

  const isTodaySydney =
    startDate && dayjs(startDate).isSame(sydneyNow.format('YYYY-MM-DD'), 'day');

  const isEndTodaySydney =
    enddate && dayjs(enddate).isSame(sydneyNow.format('YYYY-MM-DD'), 'day');

  const isEndTimeBeforeNow = (() => {
    if (!isEndTodaySydney || !endtime) return false;

    const nowSydney = dayjs().tz('Australia/Sydney');

    const currentMinutes = nowSydney.hour() * 60 + nowSydney.minute();

    const selectedMinutes = endtime.hour() * 60 + endtime.minute();

    return selectedMinutes < currentMinutes;
  })();

  const isStartTimeBeforeNow = (() => {
    if (!isTodaySydney || !starttime) return false;

    const nowSydney = dayjs().tz('Australia/Sydney');

    const currentMinutes = nowSydney.hour() * 60 + nowSydney.minute();

    // starttime may be moment OR dayjs → both support hour() & minute()
    const selectedMinutes = starttime.hour() * 60 + starttime.minute();

    return selectedMinutes < currentMinutes;
  })();

  const handleOpenConfirmModal = () => {
    if (startDate === '') {
      setErrorMessageStartDate(true);
      return;
    } else {
      setErrorMessageStartDate(false);
    }

    if (starttime === '') {
      setErrorMessageStartTime(true);
      return;
    } else {
      setErrorMessageStartTime(false);
    }

    if (enddate === '') {
      setErrorMessageEndingDate(true);
      return;
    } else {
      setErrorMessageEndingDate(false);
    }

    if (endtime === '') {
      setErrorMessageEndTime(true);
      return;
    } else {
      setErrorMessageEndTime(false);
    }
    // setConfirmModal(true);
    EditCampaignTimer();
  };
  // const EditCampaignTimer = () => {
  //   setEditLoading(true);
  //   let propertyId = profileDetails?.property?.propertyId;

  //   const params = {
  //     propertyId: propertyId,
  //     campaignStart: dayjs(startDate).format('YYYY-MM-DD'),
  //     campaignStartTime: dayjs(starttime).format('HH:mm:ss'),
  //     campaignEnd: dayjs(enddate).format('YYYY-MM-DD'),
  //     campaignEndTime: dayjs(endtime).format('HH:mm:ss'),
  //   };

  //   const pausedInput = {
  //     propertyId: propertyId,
  //     isPaused: 1,
  //   };

  //   postApiCall(UPDATE_START_TIME, unPublishPauseTimer ? pausedInput : params)
  //     .then((res) => {
  //       if (res?.status == 200) {
  //         getListInfo();
  //         // window.location.reload(true);
  //         setEditLoading(false);
  //         setStartdate('');
  //         setStarttime('');
  //         setEnddate('');
  //         setEndtime('');
  //         Swal.fire({
  //           title: res?.data?.heading ? res?.data?.heading : 'Success',
  //           text: res?.data?.message,
  //           showDenyButton: false,
  //           showCancelButton: false,
  //           icon: 'success',
  //           confirmButtonText: 'Close',
  //         });
  //         setOpenEditDialog(false);
  //       } else {
  //         setEditLoading(false);
  //         Swal.fire({
  //           title: res?.data?.heading ? res?.data?.heading : 'Error',
  //           text: res?.data?.message,
  //           showDenyButton: false,
  //           showCancelButton: false,
  //           icon: 'error',
  //           confirmButtonText: 'Close',
  //         });
  //       }
  //     })
  //     .catch(() => setEditLoading(false));
  // };

  const EditCampaignTimer = () => {
    setEditLoading(true);
    let propertyId = profileDetails?.property?.propertyId;
    const params = {
      propertyId: propertyId,
      campaignStart: dayjs(startDate).format('YYYY-MM-DD'),
      campaignStartTime: dayjs(starttime).format('HH:mm:ss'),
      campaignEnd: dayjs(enddate).format('YYYY-MM-DD'),
      campaignEndTime: dayjs(endtime).format('HH:mm:ss'),
    };
    const pausedInput = {
      propertyId: propertyId,
      isPaused: 1,
    };
    postApiCall(UPDATE_START_TIME, unPublishPauseTimer ? pausedInput : params)
      .then((res) => {
        if (res?.data?.status == 1) {
          setUnPublishPauseTimer(false);
          // getListInfo();
          // // window.location.reload(true);
          setEditLoading(false);
          setStartdate('');
          setStarttime('');
          setEnddate('');
          setEndtime('');
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Success',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          });
          setOpenEditDialog(false);
          //   getListInfo();
        } else {
          // setOpenEditDialog(false);
          // setEditLoading(false);
          // setStartdate('');
          // setStarttime('');
          // setEnddate('');
          // setEndtime('');
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }
      })
      .catch(() => setEditLoading(false));
  };

  const determineGradient = (remainingTime, stage) => {
    if (remainingTime <= 0 || isNaN(remainingTime)) {
      return '#E2E0E0';
    }
    if (
      (stage == 'ST1' && remainingTime <= 3 * 24) ||
      (stage == 'ST2' && remainingTime <= 3)
    ) {
      return 'linear-gradient(180deg, #F93939 0%, #F8B4B4 100%)';
    }
    return 'linear-gradient(180deg, #6D3BD6 0%, #6F5BDF 25.21%, #74A8F3 85.1%, #74B2F6 92.92%, #75BBF8 100%)';
  };

  const BorderLinearProgress = styled(LinearProgress)(
    ({ theme, gradientColor }) => ({
      height: 10,
      borderRadius: 5,
      marginTop: '10px',
      [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: '#E2E0E0',
      },
      [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        background: gradientColor,
        // "linear-gradient(180deg, #6D3BD6 0%, #6F5BDF 25.21%, #74A8F3 85.1%, #74B2F6 92.92%, #75BBF8 100%)",
        transform: 'rotate(-90deg)',
      },
    })
  );

  const [progress, setProgress] = useState({
    time: 0,
    unpubtime: 0,
    remainingHoursTime: 0,
    remainingHoursUnpub: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      var totalTimeMillis = moment(
        dateTimeAfterThreeDays,
        'YYYY-MM-DD HH:mm:ss:SSS'
      ).diff(moment(profileDetails?.startedAt, 'YYYY-MM-DD HH:mm:ss:SSS'));
      var remainingMillis = moment(
        new Date(
          new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
        ).getTime()
      ).diff(moment(profileDetails?.startedAt, 'YYYY-MM-DD HH:mm:ss:SSS'));
      var time = Math.floor(
        isNaN(remainingMillis)
          ? 100
          : (1 - remainingMillis / totalTimeMillis) * 100
      );

      let end = new Date(profileDetails?.startedAt).valueOf();
      let start = new Date(profileDetails?.property?.propertyCreated).valueOf();
      const now = new Date(
        new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
      ).getTime();
      var unpubtime = Math.floor((1 - (now - start) / (end - start)) * 100);

      const remainingHoursTime = totalTimeMillis
        ? (totalTimeMillis - remainingMillis) / (60 * 60 * 1000)
        : 0;

      const remainingHoursUnpub =
        end - now > 0 ? (end - now) / (60 * 60 * 1000) : 0;
      setProgress({ time, unpubtime, remainingHoursTime, remainingHoursUnpub });
    }, 1000);

    return () => clearInterval(interval);
  }, [profileDetails, dateTimeAfterThreeDays]);

  //  const TimerData = {
  //         propertyId:  params?.propertyId || params?.dashboardId,
  //         timerId: 7,
  //         timerStatus: updateCampign

  //       };

  // useEffect(() => {
  //   let timerId;

  //   if (isRunning && !isStopped) {
  //     timerId = setInterval(() => {
  //       // CounterTimer();
  //     }, 1000);
  //   }

  //   return () => {
  //     clearInterval(timerId);
  //   };
  // }, [isRunning, isStopped]);

  // const handleSelecttimer = (selectedAction) => {
  //   if (selectedAction === 'Paused') {
  //     setIsRunning(false);
  //     setIsStopped(false);
  //     setAction('Paused');
  //   } else if (selectedAction === 'Start') {
  //     setIsRunning(true);
  //     setIsStopped(false);
  //     setAction('Start');
  //   } else {
  //     setIsRunning(false);
  //     setIsStopped(true);
  //     setAction('Stopped');
  //   }
  // };
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matchesB = useMediaQuery(theme.breakpoints.between(1536, 1636));
  const [messageToBuyer, setMessageToBuyer] = useState('');
  const [forwardOfferCheckList, setForwardOfferCheckList] = useState([]);
  const [forwardtobuyer, setForwardtobuyer] = useState(false);
  const [stagetwo, setStagetwo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openBox, setOpenBox] = useState(false);
  const [actionValue, setActionValue] = useState('');

  const [timerLoading, setTimerLoading] = useState(false);

  useEffect(() => {
    if (profileDetails?.isApprovedLog != 0) {
      setStagetwo(true);
    } else {
      setStagetwo(false);
    }
    // buyerdata?.map((index, value) => {
    //   if (index?.buyerOfferDetails?.offerStatus === 'Accepted') {
    //     setStagetwo(true);
    //   }
    // });
  }, [profileDetails]);

  const Warning = () => {
    return (
      <svg
        width="38"
        height="36"
        viewBox="0 0 38 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="37.5797"
          height="36"
          rx="18"
          fill="#10D35E"
          fill-opacity="0.1"
        />
        <path
          d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
          fill="#10D35E"
        />
      </svg>
    );
  };

  const data = props?.dataProfileDetails?.PropertyDetails?.vendorStatus;

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.dataForOtherBuyersAck))
      Moxoseparationinlisting(
        'dataForBuyerAckNotST2',
        res?.dataForOtherBuyersAck
      ); //1
    if (isNotEmptyArray(res?.dataForBuyerAck))
      Moxoseparationinlisting('dataForBuyerAckST2', res?.dataForBuyerAck); //2
    if (isNotEmptyArray(res?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.dataForVendorAck); //3
  };

  const forwardOfferToBuyerFunc = () => {
    setLoading(true);
    let newArr = [];
    for (let index = 0; index < forwardOfferCheckList.length; index++) {
      const element = forwardOfferCheckList[index];
      if (element != '') {
        let obj = { offerUniqueId: element };
        newArr.push(obj);
      }
    }
    var txt = data?.price;
    var vendorOffer = txt?.match(/\d/g);
    vendorOffer = vendorOffer?.join('');
    let input = {
      propertyId: params?.dashboardId,
      campaignId: props?.dataProfileDetails?.PropertyDetails?.campaignId,
      offerUniqueId: newArr,
      timerStage: 'ST2',
      timerStatus: 'Start',
      vendorOfferPrice: vendorOffer,
    };

    stageTwoSwitching(input)
      .then((res) => {
        if (res?.status == '1') {
          // if (isNotEmptyArray(res?.dataForAutoOffer)) {
          //   let params = { requestData: res?.dataForAutoOffer };
          //   postApiCall(BUYER_AUTO_OFFER, params);
          // }
          setLoading(false);
          setForwardtobuyer(!forwardtobuyer);
          moxoapis(res);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Success',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              getListInfo();
              activityfun();
              offerdata();
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setForwardtobuyer(!forwardtobuyer);

          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => setLoading(false));
  };

  return (
    <>
      {/* { openstagetwoCommence && 

      <Stage2Commence setOpenBox={setstagetwoCommence} getListInfo={getListInfo} openBox={openstagetwoCommence } openCommenceStageTwo={openCommenceStageTwo} 
      onCloseCommenceStageTwo={onCloseCommenceStageTwo} 
      stageData={dataProfileDetails} profileDetails={profileDetails} userDetail={userDetail} 
      setStage2AcceptanceCertificate={setStage2AcceptanceCertificate} activityfun={activityfun} offerdata={offerdata} stage2AcceptanceCertificate={stage2AcceptanceCertificate}/>
    } */}
      <Typography>
        <Typography sx={counterCont}>
          <Typography sx={counterSub}>
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '5px',
                // border:"1px solid red"
                // marginLeft: Highest ? "70px" : null,
              }}
            >
              <Clock />
              <Typography
                sx={{
                  ...poppins500,
                  ...fontsize16,
                  // paddingLeft: "10px",
                  color: '#212529',
                  textAlign: 'center',
                }}
              >
                {propertystatus === 'Publish'
                  ? 'Campaign Timer'
                  : 'Countdown Timer'}
              </Typography>
            </Typography>
            {!Highest ? (
              <Typography>
                <Select
                  sx={{
                    fontFamily: 'Poppins',
                    fontWeight: '500px',
                    fontSize: '14px',
                    color: '#000000',
                    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.15)',
                    '.MuiOutlinedInput-notchedOutline': { border: 0 },
                    outline: 'none',
                  }}
                  size="small"
                  value={action}
                  border="0px"
                  style={{
                    padding: '0px 2px',
                  }}
                  // onClick={handleSelect}
                  // value={isTimerPaused ? 'Paused' : 'action'}
                  // onChange={(e) => handleSelecttimer(e.target.value)}
                  onChange={(e) => {
                    if (e.target.value === 'Pause') {
                      setOpenBox(true);
                      setActionValue('Pause');
                    } else if (e.target.value === 'Start') {
                      setOpenBox(true);
                      setActionValue('Start');
                    } else if (e.target.value === 'End') {
                      setOpenBox(true);
                      setActionValue('End');
                    } else if (e.target.value === 'Stage2') {
                      // setAction(e.target.value);
                      setOpenCommenceStageTwo(true);
                      // setForwardtobuyer(!forwardtobuyer);
                    } else if (e.target.value === 'Edit') {
                      setOpenEditDialog(!openEditDialog);
                    }
                  }}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <Typography
                          style={{
                            fontFamily: 'Poppins',
                            fontSize: '12px',
                            color: '#000000',
                            fontWeight: '500px',
                            visibility: action ? 'hidden' : 'visible',
                          }}
                        >
                          Action
                        </Typography>
                      );
                    }
                    return selected;
                  }}
                >
                  {propertystatus === 'Publish' && (
                    <MenuItem
                      value="Stage2"
                      disabled={
                        profileDetails?.stage == 'ST2' ||
                        !stagetwo ||
                        isWinner == 1
                      }
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Poppins',
                        fontWeight: '500px',
                        color: '#000000',
                        minHeight: matchessm ? '0px' : '',
                      }}
                    >
                      Stage 2
                    </MenuItem>
                  )}
                  {propertystatus === 'Publish' && (
                    <MenuItem
                      value={action === 'Pause' ? 'Start' : 'Pause'}
                      disabled={action === 'End'}
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Poppins',
                        fontWeight: '500px',
                        color: '#000000',
                      }}
                    >
                      {action === 'Pause' ? 'Resume' : 'Pause'}
                    </MenuItem>
                  )}
                  {propertystatus === 'Publish' && (
                    <MenuItem
                      value="End"
                      disabled={action === 'End'}
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Poppins',
                        fontWeight: '500px',
                        color: '#000000',
                        minHeight: matchessm ? '0px' : '',
                      }}
                    >
                      End
                    </MenuItem>
                  )}

                  {propertystatus === 'Unpublish' && (
                    <MenuItem
                      value="Edit"
                      // disabled={action === "Pause" || action === "End"}
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Poppins',
                        fontWeight: '500px',
                        color: '#000000',
                        minHeight: matchessm ? '0px' : '',
                      }}
                    >
                      Edit
                    </MenuItem>
                  )}
                  {propertystatus === 'Unpublish' && (
                    <MenuItem
                      disabled={profileDetails?.timerDuration == 0}
                      onClick={handleOpenPause}
                      style={{
                        fontSize: '12px',
                        fontFamily: 'Poppins',
                        fontWeight: '500px',
                        color: '#000000',
                        minHeight: matchessm ? '0px' : '',
                      }}
                    >
                      Pause
                    </MenuItem>
                  )}
                </Select>
              </Typography>
            ) : null}
          </Typography>
          <Dialog
            open={forwardtobuyer}
            onClose={() => setForwardtobuyer(!forwardtobuyer)}
            PaperProps={{
              sx: {
                borderRadius: '5px',
                // height: matchessm ? "350px" : "300px",/
                minWidth: matchessm ? '95%' : '650px',
                boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
                padding: matchesmd ? '30px 20px' : '30px',
                marginBottom: matchessm ? '87px' : '',
              },
            }}
          >
            <Grid container sx={{ overflowY: 'scroll', position: 'relative' }}>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchesmd ? '10px' : '14px',
                    color: '#666666',
                  }}
                >
                  {
                    props?.dataProfileDetails?.PropertyDetails?.propertyAddress
                      ?.propertyNo
                  }{' '}
                  {
                    props?.dataProfileDetails?.PropertyDetails?.propertyAddress
                      ?.streetName
                  }{' '}
                  {
                    props?.dataProfileDetails?.PropertyDetails?.propertyAddress
                      ?.landmark
                  }{' '}
                  {
                    props?.dataProfileDetails?.PropertyDetails?.propertyAddress
                      ?.state
                  }{' '}
                  {
                    props?.dataProfileDetails?.PropertyDetails?.propertyAddress
                      ?.city
                  }{' '}
                  &nbsp;
                </Typography>
              </Grid>

              <Grid
                item
                xs={12}
                display={'flex'}
                alignItems={'center'}
                padding={'12px 0px 15px 0'}
              >
                <Warning />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchesmd ? '16px' : '24px',
                    paddingLeft: '12px',
                  }}
                >
                  Commence Timer Stage 2
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchesmd ? '12px' : '16px',
                    color: '#666666',
                  }}
                >
                  Please select the buyers you would like to participate in
                  Stage 2
                </Typography>
              </Grid>

              <Grid
                item
                xs={matchessm ? 6 : 4.5}
                textAlign={'left'}
                paddingTop={matchesmd ? '10px' : '30px'}
              >
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchesmd ? '14px' : '18px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  whiteSpace={'nowrap'}
                >
                  Offer : &nbsp;
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: matchesmd ? '14px' : '18px',
                      color: '#666666',
                    }}
                  >
                    {data?.price}
                  </Typography>
                </Typography>
              </Grid>

              {/* <Grid
              item
              xs={matchessm ? 12 : 4.5}
              justifyContent={"left"}
              paddingTop={"30px"}
              display={"flex"}
              alignItems={"start"}
            >
              <Typography
                sx={{ ...poppins500, fontSize: "18px", textAlign: "right" }}
                whiteSpace={"nowrap"}
              >
                Message to Buyer :{" "}
              </Typography>
            </Grid> */}

              {/* <Grid
              item
              xs={matchessm ? 12 : 7.5}
              paddingLeft={matchessm ? null : "20px"}
              paddingTop={"25px"}
              display={"flex"}
              alignItems={"center"}
            >
              <Typography
                width={"100%"}
                sx={{
                  display: "flex",
                  alignItems: "left",
                  justifyContent: "left",
                }}
              >
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  variant="standard"
                  sx={{
                    color: "#000000",
                    // background: "transparent",
                    borderRadius: "5px",
                    // height:"50px",
                    padding: "5px",
                    border: "1px solid #F0F0F0",
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    // ".MuiFormHelperText-contained": {
                    //   margin: "0",
                    // },
                    // ".MuiOutlinedInput-root" : {
                    //   padding: "5px"

                    // }
                  }}
                  placeholder="Text message"
                  // id="outlined-basic"
                  type="tel"
                  name="name"
                  inputProps={{ style: { fontFamily: "poppins" } }}
                  InputProps={{ disableUnderline: "true" }}
                  onChange={(e) => setMessageToBuyer(e.target.value)}
                />
              </Typography>
            </Grid> */}

              <Grid
                item
                xs={12}
                paddingTop={matchesmd ? '10px' : '30px'}
                width={'100%'}
                sx={{ overflowX: 'scroll !important' }}
              >
                <EnhancedTable
                  buyeroffer={false}
                  headCells={[
                    {
                      id: 'name',
                      numeric: false,
                      disablePadding: true,
                      label: 'Name',
                    },
                    {
                      id: 'contact',
                      numeric: true,
                      disablePadding: false,
                      label: 'Contact',
                    },
                    {
                      id: 'buyerreadlines',
                      numeric: true,
                      disablePadding: false,
                      label: 'Buyer Readlines',
                    },
                    {
                      id: 'status',
                      numeric: true,
                      disablePadding: false,
                      label: 'Status',
                    },
                    {
                      id: 'offer',
                      numeric: true,
                      disablePadding: false,
                      label: 'Offer',
                    },
                    {
                      id: 'noofoffer',
                      numeric: true,
                      disablePadding: false,
                      label: 'Number of offers',
                    },
                    {
                      id: 'propertyrating',
                      numeric: true,
                      disablePadding: false,
                      label: 'Property Rating',
                    },
                    {
                      id: 'exp',
                      numeric: true,
                      disablePadding: false,
                      label: 'Exp',
                    },
                    {
                      id: 'profile',
                      numeric: true,
                      disablePadding: false,
                      label: 'Profile',
                    },
                    {
                      id: 'profile',
                      numeric: true,
                      disablePadding: false,
                      label: '',
                    },
                    {
                      id: 'action',
                      numeric: true,
                      disablePadding: false,
                      label: 'Action Required',
                    },
                  ]}
                  tableData={props?.dataProfileDetails?.BuyerRegisterDetails}
                  onClick={props.onClick}
                  id={props.id}
                  vendorstatustable={true}
                  setForwardOfferCheckList={setForwardOfferCheckList}
                  forwardOfferCheckList={forwardOfferCheckList}
                />
              </Grid>
            </Grid>

            <Grid
              item
              container
              direction="row"
              justifyContent={'flex-end'}
              gap={2}
              marginTop={2}
            >
              <Grid item>
                <Button
                  disabled={loading}
                  variant="outlined"
                  style={{
                    padding: matchessm ? '6px 23px' : '10px 39px',
                    width: '100%',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '14px',
                    color: '#666666',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    borderRadius: '5px',
                    textTransform: 'capitalize',
                  }}
                  onClick={() => setForwardtobuyer(!forwardtobuyer)}
                >
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  variant="outlined"
                  disabled={forwardOfferCheckList?.length === 0 || loading}
                  onClick={() => forwardOfferToBuyerFunc()}
                  style={{
                    padding: matchessm ? '6px 23px' : '10px 39px',
                    width: '100%',
                    height: matchessm ? '35px' : '41px',
                    fontSize: matchessm ? '12px' : '14px',
                    color: '#FFFFFF',
                    fontWeight: '400',
                    fontFamily: 'Poppins',
                    background: '#4CA4D6',
                    borderRadius: '5px',
                    textTransform: 'capitalize',
                    cursor:
                      forwardOfferCheckList?.length === 0
                        ? 'no-drop'
                        : 'pointer',
                  }}
                  // disabled={loading}
                >
                  &nbsp;Send&nbsp;
                </Button>
              </Grid>
              {loading && (
                <Grid item>
                  <CircularProgress
                    thickness={4}
                    size={matchessm ? 25 : 30}
                    style={{ color: '#4CA4D6', marginTop: '4px' }}
                  />
                </Grid>
              )}
            </Grid>
          </Dialog>

          {openBox && (
            <Timerstatus
              openBox={openBox}
              setOpenBox={setOpenBox}
              profileDetails={profileDetails}
              actionValue={actionValue}
              getListInfo={getListInfo}
              dashboard={false}
              offerdata={offerdata}
            />
          )}

          <Dialog
            open={openEditDialog}
            // onClose={() => setOpenEditDialog(!openEditDialog)}
            PaperProps={{
              sx: {
                borderRadius: '5px',
                // height: matchessm ? "350px" : "300px",/
                minWidth: matchessm ? '95%' : '400px',
                boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
                padding: matchessm ? '30px 20px' : '30px',
              },
            }}
          >
            <Grid container height={'100%'}>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchessm ? '12px' : '14px',
                    color: '#666666',
                  }}
                >
                  {'   '}
                  {profileDetails?.propertyAddress?.streetName}
                  &nbsp;
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                display={'flex'}
                alignItems={'center'}
                padding={'20px 0px'}
              >
                <Warning />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchessm ? '16px' : '24px',
                    paddingLeft: '12px',
                  }}
                >
                  Countdown Timer
                </Typography>
              </Grid>

              <Grid
                item
                xs={matchessm ? 6 : 4.5}
                textAlign={'left'}
                marginLeft={matchessm ? '0' : '55px'}
                minWidth={matchessm ? '100%' : '0'}
              >
                <Grid
                  sx={{
                    display: 'flex',
                    gap: matchessm ? '8px' : '20px',
                    flexDirection: matchessm ? 'column' : 'row',
                  }}
                >
                  <Grid item>
                    <FormLabel
                      sx={{
                        color: '#666666',
                        fontSize: matchessm ? '12px' : '17px',
                        fontFamily: 'poppins',
                        fontWeight: 400,
                      }}
                    >
                      Start Date
                    </FormLabel>
                    <div style={{ marginTop: '5px' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={['DatePicker', 'DatePicker']}
                        >
                          <DatePicker
                            // label="Pick Date"
                            sx={
                              (pick_date,
                              {
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'rgba(0, 85, 255, 0.64)',
                                },
                              })
                            }
                            // helperText={errorMessageStartDate.helperText}
                            // error={errorMessageStartDate.error}
                            inputProps={{
                              style: {
                                fontFamily: 'Poppins',
                              },
                              required: true,
                            }}
                            minDate={dayjs()}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: errorMessageStartDate,
                                helperText: errorMessageStartDate
                                  ? 'Select start date'
                                  : null,
                                FormHelperTextProps: {
                                  sx: {
                                    fontFamily: 'Poppins',
                                    fontSize: '12px',
                                  },
                                },
                              },
                            }}
                            format="DD-MM-YYYY"
                            value={startDate ? dayjs(startDate) : null}
                            onChange={(newValue) => {
                              let val = newValue.format('YYYY-MM-DD');
                              setStartdate(val);
                            }}
                            slots={{
                              openPickerIcon: Dateicon,
                            }}
                            ampm={false}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </Grid>

                  <Grid item>
                    <FormLabel
                      sx={{
                        color: '#666666',
                        fontSize: matchessm ? '12px' : '17px',
                        fontFamily: 'poppins',
                        fontWeight: 400,
                      }}
                    >
                      Start Time
                    </FormLabel>
                    <div style={{ marginTop: '5px' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={['TimePicker', 'TimePicker']}
                        >
                          <TimePicker
                            // slotProps={{ textField: { fullWidth: true } }}
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: errorMessageStartTime,
                                helperText: errorMessageStartTime
                                  ? 'Select start time'
                                  : null,
                                FormHelperTextProps: {
                                  sx: {
                                    fontFamily: 'Poppins',
                                    fontSize: '12px',
                                  },
                                },
                              },
                            }}
                            fullWidth
                            // helperText={errorMessageStartTime.helperText}
                            // error={errorMessageStartTime.error}
                            sx={
                              (pick_date,
                              {
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'rgba(0, 85, 255, 0.64)',
                                },
                              })
                            }
                            // label="Pick Time"
                            views={['hours', 'minutes']}
                            value={starttime ? dayjs(starttime) : null}
                            minTime={isTodaySydney ? sydneyNow : null}
                            onChange={(newValue) => {
                              setStarttime(newValue);
                            }}
                            slots={{
                              openPickerIcon: Timeicon,
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    {/* {errorMessageStartTime && (
                  <div>{errorMessageStartTime}</div>
                )} */}
                  </Grid>
                </Grid>
                <Grid
                  sx={{
                    display: 'flex',
                    gap: matchessm ? '8px' : '20px',
                    marginTop: matchessm ? '15px' : '25px',
                    flexDirection: matchessm ? 'column' : 'row',
                  }}
                >
                  <Grid item>
                    <FormLabel
                      sx={{
                        color: '#666666',
                        fontSize: matchessm ? '12px' : '17px',
                        fontFamily: 'poppins',
                        fontWeight: 400,
                      }}
                    >
                      End Date
                    </FormLabel>
                    <div style={{ marginTop: '5px' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={['DatePicker', 'DatePicker']}
                        >
                          <DatePicker
                            required
                            // label="Pick Date"
                            sx={
                              (pick_date,
                              {
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'rgba(0, 85, 255, 0.64)',
                                },
                              })
                            }
                            minDate={dayjs()}
                            format="DD-MM-YYYY"
                            value={enddate ? dayjs(enddate) : null}
                            // helperText={errorMessageEndingDate.helperText}
                            // error={errorMessageEndingDate.error}
                            onChange={(newValue) => {
                              let val = newValue.format('YYYY-MM-DD');
                              setEnddate(val);
                            }}
                            slots={{
                              openPickerIcon: Dateicon,
                            }}
                            slotProps={{
                              textField: {
                                fullWidth: true,

                                error: errorMessageEndingDate,
                                helperText: errorMessageEndingDate
                                  ? 'Selec end date'
                                  : null,
                                FormHelperTextProps: {
                                  sx: {
                                    fontFamily: 'Poppins',
                                    fontSize: '12px',
                                  },
                                },
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    {/* {errorMessageEndingDate && (
                  <div>{errorMessageEndingDate}</div>
                )} */}
                  </Grid>

                  <Grid item>
                    <FormLabel
                      sx={{
                        color: '#666666',
                        fontSize: matchessm ? '12px' : '17px',
                        fontFamily: 'poppins',
                        fontWeight: 400,
                      }}
                    >
                      End Time
                    </FormLabel>
                    <div style={{ marginTop: '5px' }}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                          components={['TimePicker', 'TimePicker']}
                        >
                          <TimePicker
                            slotProps={{
                              textField: {
                                fullWidth: true,
                                error: errorMessageEndTime,
                                helperText: errorMessageEndTime
                                  ? 'Select end time'
                                  : null,
                                FormHelperTextProps: {
                                  sx: {
                                    fontFamily: 'Poppins',
                                    fontSize: '12px',
                                  },
                                },
                              },
                            }}
                            fullWidth
                            sx={
                              (pick_date,
                              {
                                '.MuiOutlinedInput-notchedOutline': {
                                  borderColor: 'rgba(0, 85, 255, 0.64)',
                                },
                              })
                            }
                            views={['hours', 'minutes']}
                            value={endtime ? dayjs(endtime) : null}
                            minTime={isEndTodaySydney ? sydneyNow : null}
                            onChange={(newValue) => {
                              setEndtime(newValue);
                            }}
                            slots={{
                              openPickerIcon: Timeicon,
                            }}
                            // ampm={false}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                    {/* {errorMessageEndTime && <div>{errorMessageEndTime}</div>} */}
                  </Grid>
                </Grid>
              </Grid>

              <Grid
                item
                container
                direction="row"
                sx={{ display: 'flex', alignItems: 'center' }}
                justifyContent={'flex-end'}
                gap={matchessm ? '8px' : 2}
                marginTop={matchessm ? 2 : 4}
              >
                <Grid item>
                  <Button
                    disabled={timerLoading}
                    variant="outlined"
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      width: '100%',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '15px',
                      color: '#666666',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      border: '1px solid rgba(17, 35, 71, 0.1)',
                      borderRadius: '5px',
                      textTransform: 'none',
                    }}
                    onClick={() => {
                      setErrorMessageStartDate('');
                      setErrorMessageEndingDate('');
                      setErrorMessageEndTime('');
                      setErrorMessageStartTime('');
                      setOpenEditDialog(!openEditDialog);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid
                  item
                  sx={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    disabled={
                      !isChanged ||
                      isStartTimeBeforeNow ||
                      isEndTimeBeforeNow ||
                      timerLoading
                    }
                    onClick={() => {
                      // setConfirmBtn(confirmBtn);
                      // ActionTimer(confirmBtn);
                      // setOpenBox(!openBox);
                      // valueFunc();
                      handleOpenConfirmModal();
                    }}
                    variant="outlined"
                    sx={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      width: '100%',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '15px',
                      color: '#FFFFFF',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      background: '#4CA4D6',
                      borderRadius: '5px',
                      textTransform: 'none',
                      '&:hover': { backgroundColor: '#4CA4D6' },
                      '&.Mui-disabled': {
                        backgroundColor: '#4CA4D6',
                        color: '#fff',
                        opacity: 0.7,
                        cursor: 'not-allowed',
                        pointerEvents: 'auto',
                      },
                    }}
                    // disabled={loading}
                  >
                    Confirm
                  </Button>
                  {editLoading && (
                    <img
                      alt="Loader"
                      src={Loading}
                      className="loaderImage"
                      style={{ height: '40px', width: '40px' }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Dialog>

          <Dialog
            open={unPublishPauseTimer}
            fullWidth={'lg'}
            PaperProps={{
              sx: {
                borderRadius: '5px',
                minWidth: matchessm ? '95%' : '400px',
                boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
                padding: matchessm ? '30px 20px' : '20px',
              },
            }}
          >
            <Grid container height={'100%'}>
              <Grid item xs={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchessm ? '10px' : '14px',
                    color: '#666666',
                  }}
                >
                  {profileDetails?.propertyAddress?.streetName}
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                display={'flex'}
                alignItems={'center'}
                padding={'12px 0px 15px 0'}
              >
                <Pendingwarning />
                <Typography
                  sx={{
                    ...poppins500,
                    fontSize: matchessm ? '16px' : '24px',
                    paddingLeft: '12px',
                  }}
                >
                  Pause Campaign
                </Typography>
              </Grid>
              <Grid item md={12}>
                <Typography
                  sx={{
                    ...poppins400,
                    fontSize: matchessm ? '12px' : '16px',
                    color: '#666666',
                    marginTop: '50px',
                  }}
                >
                  Would you like to Pause the Campaign now?
                </Typography>
              </Grid>

              <Grid
                item
                container
                direction="row"
                justifyContent={'flex-end'}
                gap={2}
                marginTop={matchessm ? '15px' : 5}
              >
                <Grid item>
                  <Button
                    onClick={() => {
                      setUnPublishPauseTimer(false);
                    }}
                    variant="outlined"
                    disabled={editLoading}
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      width: '100%',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#666666',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      border: '1px solid rgba(17, 35, 71, 0.1)',
                      borderRadius: '5px',
                      textTransform: 'capitalize',
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                  }}
                >
                  <Button
                    onClick={() => {
                      EditCampaignTimer();
                    }}
                    variant="outlined"
                    disabled={editLoading}
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      minWidth: '140px',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#FFFFFF',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      background: '#4CA4D6',
                      borderRadius: '5px',
                      textTransform: 'capitalize',
                    }}
                  >
                    Confirm
                  </Button>
                  {editLoading && (
                    <img
                      alt="Loader"
                      src={Loading}
                      className="loaderImage"
                      style={{ height: '40px', width: '40px' }}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Dialog>

          <Card
            variant="outlined"
            sx={{
              height: '149px',
              border: 0,
              // boxShadow: "0px 1px 15px rgba(151, 151, 151, 0.15)",
              borderRadius: '15px',
              margin: '0px 10px 10px 10px',
              paddingTop: '10px',
            }}
          >
            {profileDetails?.timerStatus != 'End' && (
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  gap: '5px',
                }}
              >
                {/* {profileDetails?.stage == "ST1" ? (
            <Box style={{ display:"flex", justifyContent:"center" }}>
              <StageIcon />
            </Box>
          ) : profileDetails?.stage == "ST2" ? (
            <Box style={{ display:"flex", justifyContent:"center" }}>
               {profileDetails?.isReset == "1" ? <StageIcon2 /> : <Stage2SVG />}
            </Box>
          ):(
            <Box style={{ display:"flex", justifyContent:"center" }}>
            <Unpublished/>
            </Box>
            )} */}
                  {profileDetails?.timerStatus === 'End' && (
                    <Ended
                      matches450={matches450}
                      matchesB={matchesB}
                      customStyles={{ borderRadius: '0px', padding: '3px 6px' }}
                    />
                  )}
                  {profileDetails?.timerStatus !== 'End' &&
                    profileDetails?.stage === 'ST1' && (
                      <Stage1
                        matches450={matches450}
                        matchesB={matchesB}
                        customStyles={{ borderRadius: '0px', padding: '3px 6px' }}
                      />
                    )}
                  {profileDetails?.timerStatus !== 'End' &&
                    profileDetails?.stage === 'ST2' &&
                    profileDetails?.isReset === '1' && (
                      <Stage2Final
                        matches450={matches450}
                        matchesB={matchesB}
                        customStyles={{ borderRadius: '0px', padding: '3px 6px' }}
                      />
                    )}
                  {profileDetails?.timerStatus !== 'End' &&
                    profileDetails?.stage === 'ST2' &&
                    profileDetails?.isReset !== '1' && (
                      <Stage2
                        matches450={matches450}
                        matchesB={matchesB}
                        customStyles={{ borderRadius: '0px', padding: '3px 6px' }}
                      />
                    )}
                  {profileDetails?.timerStatus !== 'End' &&
                    profileDetails?.stage !== 'ST1' &&
                    profileDetails?.stage !== 'ST2' && (
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontSize: '12px',
                          color: 'white',
                          padding: '3px 12px',
                          background: '#529AEE',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          height: '20px',
                        }}
                      >
                        Unpublished
                      </Typography>
                    )}
                {profileDetails?.timerStatus == 'Pause' && (
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <PauseIcon width={24} height={24} />
                  </Box>
                )}
              </Grid>
            )}
            {/* <Box sx={{backgroundColor:'#10D35E'}} style={{width:'20%', marginLeft:"40%", paddingLeft:'2%' }}><Typography sx={{fontSize:'12px', fontFamily:'Poppins', color:'#FFFFFF'}}>STAGE 1</Typography></Box> */}
            {/* <Box sx={{backgroundColor:'#F93939'}} style={{width:'55%', marginLeft:"23%", paddingLeft:'5%' }}><Typography sx={{fontSize:'12px', fontFamily:'Poppins', color:'#FFFFFF'}}>STAGE 2 - FINAL OFFERS</Typography></Box> */}
            <CountdownTimer
              isRunning={isRunning}
              targetDate={dateTimeAfterThreeDays}
              paused={pause}
              pausestatus={
                profileDetails?.timerStatus === 'Pause' ? true : false
              }
              getListInfo={getListInfo}
              isUnPublished={
                profileDetails?.property?.status === 'Unpublish' ? true : false
              }
              stage={profileDetails?.stage}
              highestOfferId={profileDetails?.highestOfferId}
              isWinner={profileDetails?.isWinner}
              setPublish={setPublish}
              startedAt={profileDetails?.startedAt}
              individual={true}
              profileDetails={buyerregdata}
              // daysStatus={daysStatus}
              // hoursStatus={hoursStatus}
              // minutesStatus={minutesStatus}
              // secondsStatus={secondsStatus}
              // setDaysStatus={setDaysStatus}
              // setHoursStatus={setHoursStatus}
              // setMinutesStatus={setMinutesStatus}
              // setSecondsStatus={setSecondsStatus}
            />
            <Typography>
              {propertystatus === 'Unpublish' ? (
                <BorderLinearProgress
                  variant="determinate"
                  value={progress.unpubtime}
                  gradientColor={determineGradient(
                    progress.remainingHoursUnpub,
                    stage
                  )}
                  // value={isNaN(unpubtime) ? 0 : unpubtime >0 && unpubtime<100 ? unpubtime : 0}
                  // gradientColor={determineGradient(remainingHoursUnpub, stage)}
                  style={{
                    height: '16px',
                    borderRadius: '8px',
                    margin: '20px',
                  }}
                />
              ) : (
                <BorderLinearProgress
                  variant="determinate"
                  // value={isNaN(time) ? 0 : time > 100 ? 0 : time}
                  // value={isNaN(time) ? 0 : time >0 && time<100 ? time : 0}
                  // gradientColor={determineGradient(remainingHoursTime, stage)}
                  value={progress.time}
                  gradientColor={determineGradient(
                    progress.remainingHoursTime,
                    stage
                  )}
                  style={{
                    height: '16px',
                    borderRadius: '8px',
                    margin: '20px',
                  }}
                />
              )}
            </Typography>
            {openCommenceStageTwo && (
              <CommenceStageTwo
                openCommenceStageTwo={openCommenceStageTwo}
                onCloseCommenceStageTwo={onCloseCommenceStageTwo}
                stageData={dataProfileDetails}
                stage2AcceptanceCertificate={stage2AcceptanceCertificate}
                setStage2AcceptanceCertificate={setStage2AcceptanceCertificate}
                activityfun={activityfun}
                offerdata={offerdata}
                getListInfo={getListInfo}
              />
            )}
          </Card>
        </Typography>
      </Typography>
      {/* <Dialog
        open={ winerPublishdMoveToEnded || ( isSevenDaysPassed && dataProfileDetails?.PropertyDetails?.timerStatus == "End" && dataProfileDetails?.isMovedToEnded == "0" && dataProfileDetails?.PropertyDetails?.isWinner == 0) }
        fullWidth
        maxWidth={'sm'}
        PaperProps={{
          sx: {
            borderRadius: "5px",
            minWidth: matchessm ? "95%" : "400px",
            boxShadow: " -4px, 4px rgba(0, 0, 0, 0.09)",
            padding: matchessm ? "30px 20px" : "20px",
          },
        }}
      >
        <Grid container height={"100%"}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? "10px" : "14px",
                color: "#666666",
              }}
            >
              {profileDetails?.propertyAddress?.streetName}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={"flex"}
            alignItems={"center"}
            padding={"12px 0px 15px 0"}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? "16px" : "24px",
                paddingLeft: "12px",
              }}
            >
              Move Property to Archived Section?
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? "12px" : "16px",
                color: "#666666",
                marginTop: "50px",
              }}
            >
              Do you want to move this property to Archived section? 
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={"flex-end"}
            gap={2}
            marginTop={matchessm ? "15px" : 5}
          >
            <Grid item>
              <Button
                disabled={closeEndedConfirmation}
                onClick={()=>{PropertyMoveToEnded('2')}}
                variant="outlined"
                style={{
                  padding: matchessm ? "6px 23px" : "10px 39px",
                  width: "100%",
                  height: matchessm ? "35px" : "41px",
                  fontSize: matchessm ? "12px" : "14px",
                  color: "#666666",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  border: "1px solid rgba(17, 35, 71, 0.1)",
                  borderRadius: "5px",
                  textTransform: "capitalize",
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <Button
                disabled={closeEndedConfirmation}
                onClick={()=>{PropertyMoveToEnded('1')}}
                variant="outlined"
                style={{
                  padding: matchessm ? "6px 23px" : "10px 39px",
                  minWidth: "140px",
                  height: matchessm ? "35px" : "41px",
                  fontSize: matchessm ? "12px" : "14px",
                  color: "#FFFFFF",
                  fontWeight: "400",
                  fontFamily: "Poppins",
                  background: "#4CA4D6",
                  borderRadius: "5px",
                  textTransform: "capitalize",
                }}
              >
                  Move
              </Button>
              {closeEndedConfirmation && (
                <CircularProgress
                  size={27}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    color: "#4CA4D6",
                    marginTop: 0,
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog> */}
    </>
  );
}

CounterTimer.defaultProps = {
  isUnPublished: false,
};

CounterTimer.propTypes = {
  isUnPublished: PropTypes.bool,
};
export default CounterTimer;
